import { render, staticRenderFns } from "./VerifyShipper.vue?vue&type=template&id=330791f0"
import script from "./VerifyShipper.vue?vue&type=script&lang=js"
export * from "./VerifyShipper.vue?vue&type=script&lang=js"
import style0 from "./VerifyShipper.vue?vue&type=style&index=0&id=330791f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports